import axios from "../axiosConfig";
import { currentLanguage } from "../../algorithms/storage";

export const getStatusCountApi = (communityID, token) => {
  return axios.get(`Task/GetCooperationCount/${communityID}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getCommunitiesApi = (token) => {
  return axios.get(`Task/GetBarChartCooperationCount`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getMembersStatusApi = (token) => {
  return axios.get(`Task/GetCountryChartCooperationCount`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
// GetCountryChartCooperationCount